import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import {PickList} from 'primereact/picklist';
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const PermissionsView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-7">
                        <TitlePage title="Mantenimientos \ Usuarios \ Permisos"/>
                    </div>
                    <div className="p-col-5" align="right">
                        <Button label="Regresar" className="p-button-secondary"
                                onClick={props.returnUpdateUsersPage}/>&nbsp;
                        <Button label="Copiar" className="p-button-secondary"
                                onClick={props.openCopyDialog}/> &nbsp;
                        <Button label="Guardar"
                                onClick={props.assignProcesses}/>
                    </div>
                    <div className="p-col-12"><Divider/></div>

                    <div className="p-col-12 p-md-12 p-lg-12">
                        <SubtitleLabel header="Usuario" isBold={true}/>
                        <SubtitleLabel header={props.user.usuario}/>
                    </div>
                    <div className="p-col-1"/>
                    <div className="p-col-10">
                        <PickList source={props.sourceProcess} target={props.targetProcess}
                                  itemTemplate={props.processTemplate}
                                  sourceHeader={<div align="left">Pantallas Disponibles</div>}
                                  targetHeader={<div align="left">Pantallas Asignadas</div>}
                                  responsive={true}
                                  sourceStyle={{height: '500px'}}
                                  targetStyle={{height: '500px'}}
                                  onChange={props.onChangePickList}
                                  showSourceControls={false} showTargetControls={false}/>
                    </div>

                    <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                            onHide={props.onHideDialog} closable={false} style={{width: "35%"}}
                            contentStyle={{overflow:'visible'}}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-12 p-lg-12">
                                <SubtitleLabel header="Usuario" isBold={true}/>
                                <Dropdown
                                    name="userObj"
                                    filterBy="usuario"
                                    options={props.usersList}
                                    optionLabel="usuario"
                                    placeholder="Seleccione..."
                                    onChange={props.onChangeDropDown}
                                    value={props.userObj}/>
                            </div>
                        </div>
                    </Dialog>
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(PermissionsView);